import { useState, useEffect } from 'react';
import { Table, Button, Drawer, Typography, message, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { api } from '../api';
import AddressForm from './AddressForm';

const { Text } = Typography;

export default function AddressesTab() {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [drawer, setDrawer]       = useState({ open: false, data: null });

  const load = async () => {
    setLoading(true);
    try {
      setAddresses(await api.addresses.list());
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    {
      title: 'Adresse',
      key: 'addr',
      render: (_, a) => (
        <Space direction="vertical" size={0}>
          <Text>{a.street} {a.nr}</Text>
          <Text type="secondary">{a.postal_code} {a.city} {a.country}</Text>
          {a.doorbell && <Text style={{ fontSize: 12 }} type="secondary">Klingel: {a.doorbell}</Text>}
        </Space>
      ),
    },
    {
      title: 'Geo',
      key: 'geo',
      width: 160,
      render: (_, a) => a.geo_lat ? <Text style={{ fontSize: 12 }}>{a.geo_lat}, {a.geo_lon}</Text> : '–',
    },
    {
      title: '',
      key: 'actions',
      width: 60,
      render: (_, a) => (
        <Button size="small" icon={<EditOutlined />} onClick={() => setDrawer({ open: true, data: a })} />
      ),
    },
  ];

  return (
    <>
      <Table rowKey="id" columns={columns} dataSource={addresses} loading={loading} pagination={false} size="middle" />
      <Drawer
        title="Adresse bearbeiten"
        open={drawer.open}
        onClose={() => setDrawer({ open: false, data: null })}
        width={480}
        destroyOnClose
      >
        {drawer.data && (
          <AddressForm address={drawer.data} onSaved={() => { setDrawer({ open: false, data: null }); load(); }} />
        )}
      </Drawer>
    </>
  );
}
